import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import i18n from './i18n'
import store from './store'
import AsyncComputed from 'vue-async-computed'

Vue.config.productionTip = false
Vue.use(AsyncComputed);
Vue.use(VueMeta)

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
